import { createFileRoute, redirect } from '@tanstack/react-router'
import { sessionQueryOptions } from '@/entities/session'
import { AppShell } from '@/widgets/app-shell'

/**
 * Гейт кабинета. Публичная страница записи (`/b/$excursionId`) живёт вне его —
 * это отдельный анонимный контур, и никакой редирект на вход к ней не относится.
 */
export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.ensureQueryData(sessionQueryOptions)
    if (!session) throw redirect({ to: '/login' })
    return { session }
  },
  component: AppShell,
})
